import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconShowers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.37 17.2 9 13.57M10.61 15.38l2.02-1.81M3.34 15.38l2.03-1.81M15 6.39a2.19 2.19 0 0 0-2.27-3A4 4 0 0 0 5 4.45a3.63 3.63 0 0 0 .35 7.25h8A2.91 2.91 0 0 0 15 6.39Z",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgIconShowers as ReactComponent };
